import Spinner from 'src/javascripts/components/utilities/Spinner';
import BuildApiUrl from 'src/javascripts/components/tables/url/BuildApiUrl';
import DefaultTable from 'src/javascripts/components/tables/DefaultTable';
import CarbonFootprint from 'src/javascripts/components/charts/CarbonFootprint';
import QuestionnaireMetricsTable from 'src/javascripts/components/tables/QuestionnaireMetricsTable';

export default class PortfoliosCarbonFootprintsIndex {

  constructor() {}

  render() {
    const accountUrl = $('body').attr('data-account-url');

    // Start import status poll if importing
    let importPoll = () => {

      // Get generating message on page
      let isGenerating = $('.generating-message');

      // Only continue if status indicator present (if should poll for recs is true)
      if (isGenerating.length !== 0) {

        // Set Api url to get data
        let portfolioId = isGenerating.attr('data-portfolio-id');
        let modelId = isGenerating.attr('data-model-id');
        let params = {};
        params['portfolio_id'] = portfolioId;
        params['scope'] = 'portfolio';
        let url = '/' + accountUrl + '/portfolios/models/' + modelId + '/imports/check_import_status.js?' + $.param(params);

        // Execute ajax request (using js erb template to render content so can control profile styling more easily)
        // Must specify '.js' otherwise processes as JSON
        $.ajax({
          type: "POST",
          dataType: "script",
          timeout: 3000,
          url: url,
          complete() {
            setTimeout(function() { importPoll() }, 4000);
          }
        });
      }
    };

    // Poll server for status of mapped items, if generating message present
    if ($('.generating-message').length !== 0) { importPoll(); }

    // Reload with attrs
    let reloadWithSelectedParams = function() {
      let url = window.location.href;
      let params = {};
      params['portfolio_id'] = $('#questionnaire_metrics_table').attr('data-portfolio-id');
      params['metric_table_id'] = $('#questionnaire_metrics_table').attr('data-metric-table-id');
      params['full_view'] = $('#questionnaire_metrics_table').attr('data-full-view');
      params['detail_columns'] = $('#questionnaire_metrics_table').attr('data-detail-columns');
      params['excluded'] = $('#questionnaire_metrics_table').attr('data-excluded');
      params['data_types'] = $('#questionnaire_metrics_table').attr('data-data-types');
      Turbo.visit(url + '?' + $.param(params));
    }

    // // On selecting an item
    // $('.portfolios-search').bind('typeahead:select typeahead:autocomplete', function(ev, suggestion) {
    //   $('#questionnaire_metrics_table').attr('data-portfolio-id', suggestion.value);
    //   reloadWithSelectedParams();
    // })
   
    $('.year-select').change(function(e) {
      let val = $(this).val();
      let accountUrl = $('body').attr('data-account-url');
      let portfolioId = $('#profileTabContent').attr('data-portfolio-id');
      let url = "/" + accountUrl + "/portfolios/carbon_footprint"
      let params = {};
      params['portfolio_id'] = portfolioId;
      params['data_year'] = val;
      Turbo.visit(url + '?' + $.param(params));
    })


    // Show calculation summary
    if (($('#footprint_calc_summary_table').length > 0) && ($('#footprint_calc_summary_table tbody td').length === 0)) {
      let tableId = 'footprint_calc_summary_table';
      let carbonFootprintTable = new DefaultTable($('#' + tableId));
      $.when( carbonFootprintTable.render(tableId) ).then( status => carbonFootprintTable.setUp(tableId) );      
    }


  }

}